import React, { useEffect, useRef, useState } from 'react'
import '../safetyRules/safetyRules.css'
import { useLanguage } from '../../context/LanguageContext'

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000'

const QRCode = () => {
  const {
    language, visitorData, sessionId, tenantSlug,
    qrBase64, setQrBase64,
    alreadyCheckedIn, setAlreadyCheckedIn,
    checkinSubmitted, setCheckinSubmitted,
    safetyRulesReadAt,
    safetyRulesForPdf,
    allTranslations,
    flowMode,
  } = useLanguage()

  const t   = allTranslations[language] || allTranslations['en']
  const tDe = allTranslations['de']

  const [loading,         setLoading]         = useState(false)
  const [saveError,       setSaveError]       = useState(null)
  const [approvalPending, setApprovalPending] = useState(false)
  const submittingRef = useRef(false)

  // If the quiz was skipped and the check-in hasn't been submitted yet, do it now
  useEffect(() => {
    if (submittingRef.current || checkinSubmitted || alreadyCheckedIn || !visitorData || !sessionId || !tenantSlug) return
    submittingRef.current = true

    setLoading(true)
    setSaveError(null)

    fetch(`${BACKEND_URL}/api/checkin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Tenant-Slug': tenantSlug },
      body: JSON.stringify({
        sessionId,
        checkin_type: 'pre-checkin',
        visitorData,
        safetyRulesReadAt,
        safetyRulesForPdf: safetyRulesForPdf || tDe.safety_rules,
        flowMode,
        language,
      }),
    })
      .then(res => res.json().then(data => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data.detail ? `${data.error}: ${data.detail}` : (data.error || 'Request failed'))
        if (data.pending) {
          setApprovalPending(true)
          setCheckinSubmitted(true)
          return
        }
        setQrBase64(data.qrBase64)
        setCheckinSubmitted(true)
        setAlreadyCheckedIn(data.alreadyCheckedIn)
      })
      .catch(err => setSaveError(err.message))
      .finally(() => setLoading(false))
  }, [])

  if (loading) {
    return (
      <div className="viGuard__safetyRules">
        <div className="viGuard__qr-content">
          <p className="page-loading-text">{t.loading}</p>
        </div>
      </div>
    )
  }

  if (saveError) {
    return (
      <div className="viGuard__safetyRules">
        <div className="viGuard__qr-content">
          <p className="page-error-text">{saveError}</p>
        </div>
      </div>
    )
  }

  if (approvalPending) {
    return (
      <div className="viGuard__safetyRules">
        <div className="viGuard__qr-content">
          <h1 className="gradient__text">{t.approval_pending_title || 'Anfrage eingegangen'}</h1>
          <p className="subtitle">{t.approval_pending_message || 'Ihre Anfrage wird geprüft. Sie erhalten eine E-Mail, sobald Ihr Zugang genehmigt oder abgelehnt wurde.'}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="viGuard__safetyRules">
      <div className="viGuard__qr-content">

        {alreadyCheckedIn ? (
          <>
            <div className="viGuard__qr-existing-badge">⚠</div>
            <h1 className="gradient__text">{t.already_checked_in_title}</h1>
            <p className="subtitle">{t.already_checked_in_message}</p>
          </>
        ) : (
          <>
            <h1 className="gradient__text">{t.qr_title}</h1>
            <p className="subtitle">{t.qr_subtitle}</p>
          </>
        )}

        <div className="viGuard__qr-box">
          {qrBase64
            ? <img src={qrBase64} alt="QR Code" width={240} height={240} />
            : <div className="qr-placeholder">{t.loading}</div>
          }
        </div>

        <div className="viGuard__qr-meta">
          <span>{t.qr_session}: <strong>{sessionId}</strong></span>
          <span>{t.qr_visit}: <strong>{visitorData?.visitDate || '—'}</strong></span>
        </div>

        <div className="viGuard__qr-note">{t.qr_note}</div>

      </div>
    </div>
  )
}

export default QRCode
